const delay = (ms) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve(2);
        }, ms);
    });
}

export {delay}